import axios from 'axios'

/*
 * What the back office does when the API stops accepting its session.
 *
 * The API answers 401 when there is no usable session — the token expired
 * (they last twelve hours now), or it predates the role check and says nothing
 * about who holds it. That is a sign-in problem, so the only useful thing to do
 * is go back to the sign-in page and say why.
 *
 * 403 is different: the session is fine, but this account's role does not
 * cover what was asked for. Signing someone out for that would be wrong, so 403
 * is left to the screen that made the request.
 */

const REASON_KEY = 'signedOutReason'

/* A screen fires several requests at once; only the first failure acts. */
let ending = false

function onLoginPage() {
  const hash = String(window.location.hash || '')
  return hash === '' || hash === '#/' || hash.indexOf('/login') > -1
}

export function takeSignedOutReason() {
  try {
    const reason = sessionStorage.getItem(REASON_KEY)
    if (reason) sessionStorage.removeItem(REASON_KEY)
    return reason || ''
  } catch (err) {
    return ''
  }
}

export function installSessionGuard() {
  axios.interceptors.response.use(
    response => response,
    error => {
      const status = error && error.response ? error.response.status : 0
      if (status === 401 && !ending && !onLoginPage()) {
        ending = true
        try {
          sessionStorage.clear()
          sessionStorage.setItem(REASON_KEY, 'Your session has ended. Please sign in again.')
        } catch (err) {
          /* Storage blocked — signing out still has to happen. */
        }
        /* A fresh load drops the signed-in state React holds in context; the
           protected routes then send the browser to the sign-in page. */
        window.location.reload()
      }
      return Promise.reject(error)
    }
  )
}
